export default __webpack_public_path__ + "static/media/32.b9750463.png";